import types from '../types/missingInfo'
import depositActions from '../../deposit/actions/deposit'

export default class missingInfo {

  static nextStep(info) {
    return function(dispatch, getState) {

      if (!info) info = getState().domain.user.missingProfileInformation
      // const currentStep = getState().ui.missingInfo.missingInfo.get('step')
      const currentStep = 0

      let step = getNextStep(currentStep, info)

      if (step === 0) {
        switch (getState().ui.missingInfo.missingInfo.get('afterDone')) {
          case 'deposit':
            dispatch(depositActions.setStep(1))
            break
          default:
        }
      }

      dispatch({
        type: types.NEXT_STEP,
        payload: {
          step,
        },
      })
    }
  }

  static start(afterDone) {
    return function(dispatch, getState) {
      //TODO remove in the future
      window.location.href = "https://space.guru/?open=c"
      // dispatch(missingInfo.setAfterDone(afterDone))
      // dispatch(missingInfo.nextStep())
    }
  }

  static setAfterDone(afterDone) {
    return {
      type: types.SET_AFTER_DONE,
      payload: {
        afterDone,
      },
    }
  }

  static close() {
    return {
      type: types.CLOSE,
    }
  }

}

function getNextStep(currentStep, info) {
  const toCheck = [
    {},
    {step: 1, key: 'email'},
    {step: 2, key: 'phone'},
  ]

  for (let i = currentStep + 1; i < toCheck.length; i++) {
    if (info.indexOf(toCheck[i].key) !== -1)
      return toCheck[i].step
  }
  return 0
}



// WEBPACK FOOTER //
// ./src/sections/missingInfo/actions/missingInfo.js